import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ShieldCheckIcon, LockIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HERO_IMAGE, heroTestimonials } from '../data/content';
const stats = [{
  value: '+500',
  label: 'mujeres transformadas'
}, {
  value: '6',
  label: 'Tomos listos'
}, {
  value: '3',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'calificación'
}];
const bullets = ['Detox + ejercicios + alimentación + baja de cortisol listos para usar.', 'Sin improvisar. Sin dietas extremas. Sin excusas.'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-950 pb-16 pt-6 sm:pt-8" data-id="element-116" data-mp="s9zx5bx3awk3">
      <div aria-hidden="true" className="pointer-events-none absolute -left-32 top-0 h-[420px] w-[420px] rounded-full bg-rose-600/20 blur-[120px]" data-id="element-117" data-mp="nb6mdr96tjnm" />
      <div aria-hidden="true" className="pointer-events-none absolute -right-24 top-40 h-[380px] w-[380px] rounded-full bg-gold-600/15 blur-[120px]" data-id="element-118" data-mp="382p9fo05jxqf" />

      <div className="relative mx-auto max-w-6xl px-5" data-id="element-119" data-mp="3j6oc9l508oqm">
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-center text-[11px] font-semibold uppercase tracking-[0.16em] text-cream/60" data-id="element-120" data-mp="3o6aphuku24zf">
          <span className="text-gold-400" data-id="element-121" data-mp="3e963buqzm9im">Método Glúteos 360™</span>
          <span className="hidden h-1 w-1 rounded-full bg-cream/30 sm:block" data-id="element-122" data-mp="3ebiqqnfilc32" />
          <span data-id="element-123" data-mp="30ggg5mzq2yjx">La transformación femenina que sí funciona</span>
        </div>

        <div className="mt-10 grid items-center gap-12 lg:grid-cols-2" data-id="element-124" data-mp="359syjfdt6948">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="flex flex-col items-start gap-6" data-id="element-125" data-mp="2qkdd8ex1qvvx">
            <div className="flex flex-wrap gap-2" data-id="element-126" data-mp="2hjoy1gvx2phg">
              {['100% Digital', 'Acceso en 5 min', '6 Tomos completos', 'Bonos incluidos'].map(chip => <span key={chip} className="inline-flex items-center gap-1.5 rounded-full border border-cream/15 bg-cream/5 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-cream/80" data-id="element-127" data-mp="s335feo1gqy2">
                    <ZapIcon className="h-3 w-3 text-gold-400" aria-hidden="true" data-id="element-128" data-mp="dd5eiqyq5n56" />
                    {chip}
                  </span>)}
            </div>

            <h1 className="font-display text-4xl uppercase leading-[0.95] tracking-tight text-cream sm:text-6xl" data-id="element-129" data-mp="1ayjilhmnxm7u">
              MegaPack
              <span className="block text-gold-500" data-id="element-130" data-mp="111ycesywq52f">Reto 30 días fit</span>
            </h1>

            <p className="text-xl font-bold text-cream sm:text-2xl" data-id="element-131" data-mp="x1nwanhehy9u">
              Tu transformación completa. Lista. Desde hoy.
            </p>

            <p className="max-w-xl text-base leading-relaxed text-cream/70 sm:text-lg" data-id="element-132" data-mp="3lu9wv02xxwap">
              El sistema N°1 para mujeres que quieren resultados reales —{' '}
              <span className="font-semibold text-rose-400" data-id="element-133" data-mp="1xacfj35u5jt8">
                Glúteos + Cintura + Salud Hormonal
              </span>
            </p>

            <ul className="flex flex-col gap-2.5" data-id="element-134" data-mp="218jwnz47on4y">
              {bullets.map(b => <li key={b} className="flex items-start gap-3 text-sm text-cream/80 sm:text-base" data-id="element-135" data-mp="267wiqhn9dq6h">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold-500" aria-hidden="true" data-id="element-136" data-mp="2b2smgf1uy1zf" />
                  <span data-id="element-137" data-mp="2kxu8v34r0pyb">{b}</span>
                </li>)}
            </ul>

            <div className="w-full max-w-md" data-id="element-138" data-mp="2p08vlybjg9uv">
              <CtaButton data-id="element-139" data-mp="2oye6s8x5bxli">Quiero mi MegaPack ahora</CtaButton>
            </div>

            <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs font-medium text-cream/55" data-id="element-140" data-mp="2tz1yyxx42khb">
              <span className="inline-flex items-center gap-1.5" data-id="element-141" data-mp="uoaj9nhxmxur">
                <ShieldCheckIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-142" data-mp="zmlvg4vp9kg5" /> Garantía 7
                días
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-143" data-mp="4dgyix4pnr96">
                <LockIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-144" data-mp="3vgvtuirmsz1i" /> Pago seguro
              </span>
              <span data-id="element-145" data-mp="e91uoen3lxb0">Mercado Pago</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.94
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          ease: 'easeOut',
          delay: 0.1
        }} className="relative mx-auto w-full max-w-md" data-id="element-146" data-mp="9biidk9ynulp">
            <div className="absolute inset-x-6 bottom-6 top-10 rounded-[2rem] bg-rose-600/20 blur-2xl" aria-hidden="true" data-id="element-147" data-mp="3rg3klpireu58" />
            <img src={HERO_IMAGE} alt="MegaPack Reto 30 Días Fit: guía completa impresa junto a banda elástica, mat de yoga, pelotas y planillas de seguimiento" className="relative w-full rounded-[2rem] border border-cream/10 object-cover shadow-2xl" data-id="element-148" data-mp="3mp3naj5qaa27" />
          </motion.div>
        </div>

        <dl className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-cream/10 bg-cream/10 sm:grid-cols-4" data-id="element-149" data-mp="19hchk9janxc7">
          {stats.map(s => <div key={s.label} className="bg-ink-900 px-4 py-5 text-center" data-id="element-150" data-mp="zliwg1rievit">
              <dt className="sr-only" data-id="element-151" data-mp="14j165udcperv">{s.label}</dt>
              <dd className="font-display text-2xl text-gold-500 sm:text-3xl" data-id="element-152" data-mp="14ju3y5uc0txv">{s.value}</dd>
              <dd className="mt-1 text-[11px] uppercase tracking-wide text-cream/55" data-id="element-153" data-mp="1s9ojww9y6ymc">{s.label}</dd>
            </div>)}
        </dl>

        <div className="mt-8 grid gap-4 md:grid-cols-3" data-id="element-154" data-mp="1j8qmwxxxfrd9">
          {heroTestimonials.map(t => <figure key={t.name} className="flex flex-col gap-3 rounded-2xl border border-cream/10 bg-ink-800/60 p-5" data-id="element-155" data-mp="1n9sb8jqb2j0g">
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-156" data-mp="7s0ct3qdufed">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-157" data-mp="2ehaq1opd8k6y" data-mpi={i} />)}
              </div>
              <blockquote className="text-sm leading-relaxed text-cream/80" data-id="element-158" data-mp="24qz8gzcrechl">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-1" data-id="element-159" data-mp="1ztfsnv0exrnj">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-rose-600/30 text-xs font-bold text-rose-400" data-id="element-160" data-mp="1vqt1lwbkgare">
                  {t.initials}
                </span>
                <span className="text-xs text-cream/60" data-id="element-161" data-mp="1lsws18ya1nve">
                  <span className="block font-semibold text-cream/85" data-id="element-162" data-mp="1ltesyivvwq9n">{t.name}</span>
                  {t.city}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </header>;
}